export const getClientTz = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Sao_Paulo';
